/**
 * Logo Ticker Cards
 * Infinite horizontal scroll animation for logo card carousels
 */

(function() {
  'use strict';

  function initTicker(container) {
    const track = container.querySelector('.logo-ticker-cards__track');
    const items = container.querySelector('.logo-ticker-cards__items');
    if (!track || !items) return;

    const speed = parseInt(container.dataset.tickerSpeed) || 70;
    const reverse = container.dataset.tickerReverse === 'true';
    const pauseOnHover = container.dataset.tickerPause === 'true';

    let clone = track.querySelector('.logo-ticker-cards__items--clone');

    function calculateAndAnimate() {
      const trackWidth = track.parentElement.getBoundingClientRect().width;
      const itemsWidth = items.getBoundingClientRect().width;
      const gap = parseInt(getComputedStyle(items).columnGap) || 16;

      if (!itemsWidth || !trackWidth) return;

      if (!clone) {
        clone = document.createElement('div');
        clone.className = 'logo-ticker-cards__items logo-ticker-cards__items--clone';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      clone.innerHTML = items.innerHTML;

      const totalWidth = itemsWidth + gap;
      const duration = totalWidth / speed;

      track.style.setProperty('--ticker-duration', `${duration}s`);
      track.style.setProperty('--ticker-direction', reverse ? 'reverse' : 'normal');
      track.style.setProperty('--ticker-width', `${totalWidth}px`);
      track.style.setProperty('--ticker-gap', `${gap}px`);
      track.style.setProperty('--ticker-pause-on-hover', pauseOnHover ? 'paused' : 'running');
    }

    calculateAndAnimate();

    const resizeObserver = new ResizeObserver(calculateAndAnimate);
    resizeObserver.observe(track.parentElement);
    resizeObserver.observe(items);
  }

  function init() {
    const tickers = document.querySelectorAll('[data-ticker-cards]');
    tickers.forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const ticker = e.target.querySelector('[data-ticker-cards]');
    if (ticker) initTicker(ticker);
  });
})();
